import type { CellProps } from 'react-table';
import type { BrandsTableItem } from './interfaces';
import { Tags } from './Tags';

export default function BrandTags({ row: { original: data } }: CellProps<BrandsTableItem>) {
  return <Tags tags={data.tags} maxTags={1} />;
}

export { BrandTags };